import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/export-duck";
import { TransportWithPicking } from "interfaces/transport";

const { Types, Creators } = createActions(
  {
    request: ["query", "onSuccess"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "EXPORT__PICKINGS_LOG_" }
);

export interface ExportPickingsLogState extends IState {
  data: TransportWithPicking[];
}

interface ISuccessExportPickingsLogAction extends ISuccessAction {
  data: TransportWithPicking[];
}

const INITIAL_STATE: ExportPickingsLogState = {
  data: [],
  loading: false,
  error: null,
};

const request = (state: ExportPickingsLogState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (
  state: ExportPickingsLogState,
  action: ISuccessExportPickingsLogAction
) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: ExportPickingsLogState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const exportPickingsLog = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ExportPickingsLogTypes = Types;
export const ExportPickingsLogActions = Creators;